    import { useEffect, useState } from "react";
import HTTP from "../../config/axios";
import { Container } from "react-bootstrap";
const SellCar = () => {
    const [sellCarBannerCms, setSellCarBannerCms] = useState<any>({});
  const [isMobile, setIsMobile] = useState(false)
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const mobile = width <= 767;

      setIsMobile(mobile);
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);

    useEffect(() => {
        const getCmsContent = async () => {
            let SellCarBanner = "sell-car-banner"
            const response = await HTTP.get(`/api/cms/fetch-one/${SellCarBanner}`);
            const { data: { status, data, msg, error } } = response
            setSellCarBannerCms(data)
        }
        getCmsContent()
    }, [])
//
    const backgroundImageUrl = `${process.env.REACT_APP_CLOUDFRONT_URL}/sell_car_banner/Sell-car-page-Swift-1200×600.jpg`;
    const backgroundImageUrlMobile = `${process.env.REACT_APP_CLOUDFRONT_URL}/sell_car_banner/Sell-car-page-Swift-390×920.jpg`;
    
    return (
        <Container fluid className="top-banner-class-fit d-flex" style={{ backgroundImage: `url(${isMobile ? backgroundImageUrlMobile : backgroundImageUrl})` }}>
            <Container className="my-auto px-0">
                <div dangerouslySetInnerHTML={{ __html: sellCarBannerCms && sellCarBannerCms.content }}></div>
            </Container>
        </Container>
    );

};

export default SellCar;
